import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
// import "../style.css";
import Quiz from "./quiz";

class QuizModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      unmountOnClose: true,
    };
  }

  toggle = () => {
    this.props.that.setState({ quizModal: false });
  };

  changeUnmountOnClose(e) {
    let value = e.target.value;
    this.setState({ unmountOnClose: JSON.parse(value) });
  }

  render() {
    const { opener, quizData } = this.props;
    return (
      <div>
        <Modal
          isOpen={opener}
          toggle={this.toggle}
          unmountOnClose={this.state.unmountOnClose}
          size="lg"
          className="quizModal"
        >
          <ModalHeader toggle={this.toggle} className="quizModalHeader">
            <strong className="white">
              <b>QUIZ</b>
            </strong>{" "}
          </ModalHeader>
          <ModalBody>
            <Quiz quizData={quizData} />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default QuizModal;
